(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sportx-patches"] && !Shopify.designMode) return;
  try {
    if (!window.sxPatchGuideBound) {
  window.sxPatchGuideBound = true;
  document.addEventListener('click', function(event) {
    const opener = event.target.closest('[data-sx-patch-help]');
    if (opener) {
      const guide = document.getElementById(opener.getAttribute('aria-controls'));
      if (guide && !guide.open) guide.showModal();
      return;
    }
    const closer = event.target.closest('[data-sx-patch-close]');
    if (closer) closer.closest('dialog').close();
    if (event.target.matches('dialog.sx-patch-guide')) {
      const bounds = event.target.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
